export default __webpack_public_path__ + "static/media/Q3_2021.dfb9267d.png";